import React from 'react';
import PropTypes, { InferProps } from 'prop-types';
import GlobalStyles from '@mui/material/GlobalStyles';
import {
  createTheme,
  ThemeProvider,
} from '@mui/material/styles';
import {
  theme as themeDefault,
  hyphenation,
} from './index';
import colorsDefault from './colors';

export const executiveColors = {
  ...colorsDefault,
  primary: 'rgb(0, 0, 0)',
  primaryFallback: 'rgb(0, 0, 0)',
  secondary: 'rgb(0, 0, 0)',
  primaryText: 'rgb(0, 0, 0)',
} as const;

export const theme = createTheme({
  ...themeDefault,
  colors: {
    ...themeDefault.colors,
    ...executiveColors,
  },
  palette: {
    ...themeDefault.palette,
    primary: {
      main: executiveColors.primary,
    },
    primaryFallback: {
      main: executiveColors.primaryFallback,
    },
    secondary: {
      main: executiveColors.secondary,
    },
  },
  typography: {
    ...themeDefault.typography,
    overline: {
      ...themeDefault.typography.overline,
      color: executiveColors.primary,
    },
  },
});

const globalStyles = (
  <GlobalStyles styles={{
    ':root': {
      ...hyphenation,
      overflowY: 'scroll',
    },
  }}
  />
);

export const themePropertyTypes = {
  children: PropTypes.node,
};

export type ThemeProperties = InferProps<typeof themePropertyTypes>;

export default function ThemeWrapper({ children }: ThemeProperties) {
  return (
    <ThemeProvider theme={theme}>
      {globalStyles}
      {children}
    </ThemeProvider>
  );
}

ThemeWrapper.propTypes = themePropertyTypes;
